import { render } from "./WonderListItem.vue?vue&type=template&id=0ff0e150"
import script from "./WonderListItem.vue?vue&type=script&lang=js"
export * from "./WonderListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__